import PropTypes from "prop-types";

const propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  label: PropTypes.string
};

export default propTypes;
